/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preparing_Source_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Preparing source Event Group for translation" |
*
* @param {Preparing_Source_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preparing_source_event_group = /** @type {((inputs?: Preparing_Source_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preparing_Source_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation du groupe d’événements source pour la traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorbereitung der Quellereignisgruppe für die Übersetzung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preparazione del gruppo di eventi di origine per la traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подготовка исходной группы событий к переводу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preparación del grupo de eventos de origen para la traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("准备源事件组进行翻译")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳用のソースイベントグループを準備しています")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद के लिए स्रोत इवेंट समूह तैयार करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preparando o grupo de eventos de origem para tradução.")
	return /** @type {LocalizedString} */ ("Preparing source Event Group for translation")
});